import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

//
import IMGCEO from "../../../assets/images/about-ceo.jpg";

export default function AboutCeo() {
  const { t } = useTranslation();

  return (
    <StyledAboutCeo>
      <div className="container">
        <div className="about-ceo__wrap">
          <div className="about-ceo__left">
            <h1 dangerouslySetInnerHTML={{ __html: t("aboutCeoTitle") }} />
            <p dangerouslySetInnerHTML={{ __html: t("aboutCeoText") }} />
          </div>
          <div className="about-ceo__right"></div>
        </div>
      </div>
      <div className="about-ceo__img">
        <img src={IMGCEO} alt="IMGCEO" />
      </div>
    </StyledAboutCeo>
  );
}

const StyledAboutCeo = styled.section`
  background-color: var(--white);
  position: relative;

  .about-ceo {
    &__img {
      position: absolute;
      top: 0;
      right: 0;
      width: 50%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &__wrap {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    &__left {
      padding: 140px 80px 140px 0;
      h1 {
        color: var(--title);
        font-size: var(--fs-section-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: var(--lh-title);
        text-align: center;
        margin-bottom: 32px;

        span {
          font-weight: 700;
        }
      }

      p {
        color: var(--text-2);
        font-size: var(--fs-body-lg);
        font-style: normal;
        font-weight: var(--fw-regular);
        line-height: var(--lh-body-lg);
        text-align: left;
      }
    }
  }
`;
